import type { FC } from "react";
import { Wrapper, TitleWrapper, Icon, Title, List, BulletItem, BulletText } from "./PackageDetailsStyled";
import { i18nFilter } from "app/filters/i18nFilter";
import { SWReactIcons } from "@similarweb/icons";
import { AssetsService } from "app/services/AssetsService";
import { colorsPalettes } from "@similarweb/styles";

const translate = i18nFilter();

interface IPackageDetails {
    isSI: boolean;
}
export const PackageDetails: FC<IPackageDetails> = ({ isSI }) => {
    const bullets: Array<string> = isSI
        ? [
              translate("pro.packages.details.si.item.1"),
              translate("pro.packages.details.si.item.2"),
              translate("pro.packages.details.si.item.3"),
              translate("pro.packages.details.si.item.4"),
              translate("pro.packages.details.si.item.5"),
          ]
        : [
              translate("pro.packages.details.item.1"),
              translate("pro.packages.details.item.2"),
              translate("pro.packages.details.item.3"),
              translate("pro.packages.details.item.4"),
              translate("pro.packages.details.item.5"),
          ];

    return (
        <Wrapper>
            <TitleWrapper>
                <Icon
                    src={AssetsService.assetUrl(
                        isSI ? `/images/trial-modal/sales.svg` : `/images/trial-modal/starter.svg`,
                    )}
                    alt={""}
                />
                <Title>{translate(isSI ? "pro.packages.details.si.title" : "pro.packages.details.title")}</Title>
            </TitleWrapper>
            {bullets?.length ? (
                <List>
                    {bullets.map((item, index) => (
                        <BulletItem key={index}>
                            <SWReactIcons
                                iconName={"checked"}
                                size={"xs"}
                                iconColor={colorsPalettes.blue[400]}
                            />
                            <BulletText>{item}</BulletText>
                        </BulletItem>
                    ))}
                </List>
            ) : null}
        </Wrapper>
    );
};
